import React from 'react';
import PropTypes from 'prop-types';

import { _ } from 'utils/i18n';

import Row from 'scripts/components/Row';
import Column from 'scripts/components/Column';
import BaseModal from 'scripts/components/Modal';

import Footer from './Footer';
import ReasonSelect from './ReasonSelect';

const Text = _('Please chose a reason why you want to abort:');
const WarningText = _('Attention: Your progress in this exercise will not be saved. If you abort, you will have to start the exercise again from the beginning.');
const AutoCloseText = _('This window will close automatically in %(seconds)s seconds.');

const Modal = ({ title, onCancel, secondsLeft, onInteract, ...props }) => {
    const footer = <Footer {...props} onCancel={onCancel} />;

    return (
        <BaseModal title={title} onDismiss={onCancel} footer={footer} fixedFooter>
            <div onPointerDown={onInteract}>
                <Row>
                    <Column size={12}>
                        <p className="info">{Text}</p>
                        <p className="info" style={{ color: '#d32f2f', fontWeight: 'bold' }}>{WarningText}</p>
                    </Column>
                </Row>
                <form id="support-form">
                    <ReasonSelect {...props} />
                </form>
            </div>
            {secondsLeft !== null && <Row>
                <Column size={12}>
                    <p className="info" style={{ fontStyle: 'italic' }}>
                        {AutoCloseText.interpolate({ seconds: secondsLeft })}
                    </p>
                </Column>
            </Row>}
        </BaseModal>
    );
};

Modal.propTypes = {
    ...Footer.propTypes,
    ...ReasonSelect.propTypes,
    title: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    // `null` once the participant starts filling in the dialog: the countdown
    // is stopped and the notice is hidden.
    secondsLeft: PropTypes.number,
    onInteract: PropTypes.func.isRequired,
};

Modal.defaultProps = {
    secondsLeft: null,
};

export default Modal;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonAbortModal/Modal.js